import styled, { css, keyframes } from 'styled-components';
import {
  Typography,
  Button,
  Clip as DefaultClip,
  User as DefaultUser,
  Checkbox as DefaultCheckbox,
  OutlinedCard as DefaultOutlinedCard,
  ChevronDown as DefaultChevronDown,
  Dots as DefaultDots,
} from '~components';
import { ChevronDownProps } from './types';
import { FooterProps } from './types';

const User = styled(DefaultUser)`
  color: ${({ theme }) => theme.color.icon.neutral.inverted};
  width: 16px;
  margin-left: ${({ theme }) => theme.spacing.km2};
`;

const Clip = styled(DefaultClip)`
  margin-left: ${({ theme }) => theme.spacing.km2};
`;

export const ButtonWithUser = styled(Button).attrs({
  icon: <User />,
  width: 'fit-content',
  variant: 'primary',
})`
  margin-left: auto;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: 100%;
    margin-left: 0;
  }
`;
export const ButtonWithClip = styled(Button).attrs({
  icon: <Clip />,
  width: 'fit-content',
  variant: 'secondary',
})`
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: 100%;
  }
`;
export const Footer = styled.footer<FooterProps>`
  width: 100%;
  ${({ $hasSpacingTop }) =>
    $hasSpacingTop &&
    css`
      margin-top: ${({ theme }) => theme.spacing.km8};
    `}

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-top: ${({ theme }) => theme.spacing.km8};
  }
`;

export const CheckboxLabel = styled(Typography).attrs({ as: 'span' })`
  font-size: ${({ theme }) => theme.font.size.m4};
  color: ${({ theme }) => theme.color.text.neutral.default};
  margin-right: ${({ theme }) => theme.spacing.km4};
  letter-spacing: -0.03em;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-right: ${({ theme }) => theme.spacing.km0};
  }
`;

export const Checkbox = styled(DefaultCheckbox)`
  align-self: flex-end;
  margin-bottom: ${({ theme }) => theme.spacing.km3};

  && {
    margin-left: ${({ theme }) => theme.spacing.km12};

    @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
      margin-left: ${({ theme }) => theme.spacing.km0};
      margin-bottom: ${({ theme }) => theme.spacing.km8};
    }
  }
`;

export const OutlinedCard = styled(DefaultOutlinedCard)`
  margin-bottom: ${({ theme }) => theme.spacing.km6};
  position: relative;
`;

const rotate = keyframes`
  from {
    transform:  rotate(0deg);
  }
  to {
    transform: rotate(180deg);
  }
`;

const rotateBack = keyframes`
  from {
    transform:  rotate(180deg);
  }
  to {
    transform: rotate(0deg);
  }
`;

export const ChevronDown = styled(DefaultChevronDown)<ChevronDownProps>`
  position: absolute;
  top: 45px;
  right: 92px;
  color: ${({ theme }) => theme.color.icon.brand.default};
  cursor: pointer;

  ${({ $isFormPendent }) =>
    $isFormPendent &&
    css`
      visibility: hidden;
    `}

  ${({ $isCardExpanded }) =>
    css`
      animation: ${$isCardExpanded ? rotate : rotateBack} 0.8s forwards normal;
    `}

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    top: 22px;
    right: 47px;
  }
`;

export const Dots = styled(DefaultDots)`
  position: absolute;
  color: ${({ theme }) => theme.color.icon.brand.default};
  cursor: pointer;
`;

export const Tooltip = styled.span`
  display: none;
  position: absolute;
  right: calc(100% - 25px);
  top: 32px;
  background: ${({ theme }) => theme.color.background.neutral.default};
  padding-top: ${({ theme }) => theme.spacing.km5};
  padding-bottom: ${({ theme }) => theme.spacing.km5};
  padding-left: ${({ theme }) => theme.spacing.km3};
  padding-right: ${({ theme }) => theme.spacing.km3};
  box-shadow: 0px 8px 16px rgba(59, 64, 79, 0.18);
  border-radius: 12px;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  font-weight: ${({ theme }) => theme.font.weight.regular};
  font-size: ${({ theme }) => theme.font.weight.regular};
  line-height: 140%;
  letter-spacing: -0.02em;
  color: #636b7e;
  align-items: center;

  & > svg {
    margin-right: ${({ theme }) => theme.spacing.km3};
  }
`;

export const WrapperRelative = styled.div`
  position: absolute;
  top: 37px;
  right: 40px;
  width: 30px;
  height: 40px;

  :hover > ${Tooltip} {
    display: flex;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    top: 15px;
    right: 12px;
  }
`;
